import { render, staticRenderFns } from "./BusinessPaymentLogs.vue?vue&type=template&id=441166b5&"
import script from "./BusinessPaymentLogs.vue?vue&type=script&lang=js&"
export * from "./BusinessPaymentLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports